/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { emptyValidation } from "../../../../../helpers/validation";
import salesDashboardActions from "../../../../Sales/Dashboard/redux/actions";
import { Button, Box } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';
import moment from 'moment';



export const InactiveCustomers = (props) => {
    const { visible, title, onInactiveCustomersVisible } = props;
    const { inactiveCustomersLoader, inactiveCustomersDetails } = useSelector(state => state.salesDashboardReducer);
    const [reportOpen, setReportOpen] = useState(false);
    const [value, setValue] = useState('');
    const { businessDetails } = useSelector(state => state.homeReducer);

    const [error, setError] = useState('');


    const dispatch = useDispatch();

    const handleClose = () => {
        onInactiveCustomersVisible(false);
        setValue('');
        setError('');
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const inactiveCustomersFilter = (e) => {
        e.preventDefault();
        let emptyDays = emptyValidation('Days', value);

        if (emptyDays.isValid) {
            let url = '';
            url = 'inactiveCustomer/' + value;
            dispatch({ type: salesDashboardActions.INACTIVE_CUSTOMERS_START, url: url });
            setReportOpen(true);
            onInactiveCustomersVisible(false);
        } else {
            setError(emptyDays.errors)
        }
    }

    const inactiveCustomersTitle = (value) => {
        switch (value) {
            case 60: return 'Below 60 days';
            case 90: return 'Below 90 days';
            case 120: return 'Below 120 days';
            default: return 'Beyond 120 days';
        }
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => inactiveCustomersFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={["Number of Days ", <span key="Number of Days" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Number of Days' }]}
                                details={[{ "id": 60, "label": "Below 60 days" }, { "id": 90, "label": "Below 90 days" }, { "id": 120, "label": "Below 120 days" }]}
                                parentValue={customObject([{ "id": 60, "label": "Below 60 days" }, { "id": 90, "label": "Below 90 days" }, { "id": 120, "label": "Below 120 days" }], value)}
                                onChange={(data) => setValue(data.id)}
                                position={'bottom'}
                                id={idNamingConversion('Number of Days', 'inactiveCustomers', 'DropDown')}
                                parentError={error}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn)}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn)}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{inactiveCustomersTitle(value)}</p>
                        </div>
                        {
                            inactiveCustomersLoader ? <div className={classes.loadMoreCircle}></div> : <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={3}><h6>Cust. ID</h6></Col>
                                    <Col span={4}><h6>Name</h6></Col>
                                    <Col span={5}><h6>Email</h6></Col>
                                    <Col span={3}><h6>Phone Number</h6></Col>
                                    <Col span={3}><h6>Last Inv. Id</h6></Col>
                                    <Col span={3}><h6>Last Inv. Amount</h6></Col>
                                    <Col span={3}><h6>Last Inv. Date</h6></Col>
                                </Row>
                                {
                                    inactiveCustomersDetails?.inactiveCustomer && inactiveCustomersDetails?.inactiveCustomer?.length > 0 ?
                                        inactiveCustomersDetails?.inactiveCustomer?.map((data, i) => (
                                            <Row gutter={10} key={i} className={clsx(classes.bill, 'no-break')}>
                                                <Col span={3}><p>{data?.serialNo || '---'}</p></Col>
                                                <Col span={4}><p>{data?.customerName || '----'}</p></Col>
                                                <Col span={5}><p>{data?.email || '---'}</p></Col>
                                                <Col span={3}><p>{data?.phoneNumber}</p></Col>
                                                <Col span={3}><p>{data?.lastInvoice || '---'}</p></Col>
                                                <Col span={3}><p>{data?.lastInvoiceAmount ? `₹ ${currencyFormat(data?.lastInvoiceAmount)}` : '---'}</p></Col>
                                                <Col span={3}><p>{data?.lastInvoiceDate ? moment(data?.lastInvoiceDate).format('YYYY-MM-DD') : '---'}</p></Col>
                                            </Row>
                                        )) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                            </>
                        }
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}